import * as React from 'react';

// eslint-disable-next-line no-restricted-imports
import { AppToggleButtonProps, useAppToggleButton } from '@1js/acui-button/lib/Next';

import { renderRibbonControlLabel } from '../../RibbonButton/next';
import { useRibbonButtonVariant } from '../../RibbonButton/next/useRibbonButtonVariant';
import { RibbonToggleButtonInternalProps } from '../RibbonToggleButton.props';
import { RibbonToggleButtonProps, RibbonToggleButtonState } from './RibbonToggleButton.types';
/**
 * Given user props, returns state for a `RibbonToggleButton`.
 */
export const useRibbonToggleButton = (
  props: RibbonToggleButtonInternalProps,
  ref: React.Ref<HTMLButtonElement>
): RibbonToggleButtonState => {
  const { dataAutomationType, label, onRenderText, size, variant, variantId } = props;

  const appToggleButtonState = useAppToggleButton(
    {
      ...props,
      children: renderRibbonControlLabel(label, size, onRenderText),
      dataAutomationType: dataAutomationType ?? 'RibbonToggleButton',
      size: size?.toLowerCase() as RibbonToggleButtonProps['size'],
    } as AppToggleButtonProps,
    ref
  );

  useRibbonButtonVariant(
    appToggleButtonState as RibbonToggleButtonState,
    variant as RibbonToggleButtonState['variant'],
    variantId as RibbonToggleButtonState['variantId']
  );

  return appToggleButtonState;
};
